import React from 'react'
import CartItem from '../Components/CartItems/CartItem'

const Cart = () => {
  return (
    <div>
      <CartItem />
    </div>
  )
}

export default Cart
